module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "calendar_tab calendar-tab-pc"
  }, [_c('div', {
    staticClass: "calendar-result "
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('calendar-header', {
    attrs: {
      "nameCodapp": _vm.labels[_vm.nowLang].nameCodapp,
      "linkDisp": false
    }
  }), _vm._v(" "), _c('filter-date', {
    attrs: {
      "showTabDate": _vm.showTabDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-pc"
  }, [_vm._l((_vm.filterCalendarTab({
    tab: 'tab2',
    calendarTabRows: _vm.calendarTab2.rows
  })), function(value) {
    return [_c('div', {
      staticClass: "panel-body box-tab2 add-border"
    }, [_c('div', {
      staticClass: "row set-font-tab2"
    }, [_c('div', {
      staticClass: "col-xs-12 font-bold"
    }, [_c('i', {
      staticClass: "fa fa-clock-o color-skin",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "text_time color-skin"
    }, [_vm._v(_vm._s(value.descTime))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('i', {
      staticClass: "fa fa-map-marker i1 color-skin",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "text_time color-skin"
    }, [_vm._v(_vm._s(value.place))])])]), _vm._v(" "), _c('calendar-detail', {
      attrs: {
        "description": _vm.labels[_vm.nowLang].description,
        "descDetail": value.descDetail
      }
    })], 1)]
  })], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23ad6e04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar_tab2.vue
// module id = 3628
// module chunks = 1